export const authTypes = {
  AUTH_USER: "auth_user",
  UNAUTH_USER: "unauth_user",
  AUTH_ERROR: "auth_error",
  FETCH_SIGNED_IN_USER: "fetch_signed_in_user",
  CLEAR_AUTH_ERRORS: "clear_auth_errors",
  GET_SESSION_ID_SUCCESS: "GET_SESSION_ID_SUCCESS",
  GET_SESSION_ID_ERROR: "GET_SESSION_ID_ERROR",
}